import { render, staticRenderFns } from "./AfterTourneyPage.vue?vue&type=template&id=009cd28c&"
import script from "./AfterTourneyPage.vue?vue&type=script&lang=ts&"
export * from "./AfterTourneyPage.vue?vue&type=script&lang=ts&"
import style0 from "./AfterTourneyPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports